import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { fr } from "../content/fr";
import { logConsent } from "../lib/api";

const KEY = "viralya-consent";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
  }, []);

  const decide = async (choix) => {
    localStorage.setItem(KEY, choix);
    setVisible(false);
    if (choix === "accepte") window.dispatchEvent(new Event("viralya-consent"));
    try {
      await logConsent(choix, { mesure: choix === "accepte" });
    } catch (e) {
      /* consent log is best-effort; UI must not block */
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="consent"
          role="dialog"
          aria-label={fr.consent.title}
          data-testid="consent-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
        >
          <h4>{fr.consent.title}</h4>
          <p>{fr.consent.body}</p>
          <div className="consent__actions">
            <button className="btn btn--ghost" onClick={() => decide("refuse")} data-testid="consent-refuse">
              {fr.consent.refuse}
            </button>
            <button className="btn btn--primary" onClick={() => decide("accepte")} data-testid="consent-accept">
              {fr.consent.accept}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
